(() => {
  const root = document.documentElement;
  const storageKey = 'theme-preference';
  const validMode = value => value === 'light' || value === 'dark';
  const system = window.matchMedia('(prefers-color-scheme: dark)');
  const storeDefault = root.getAttribute('data-color-mode');
  let preference = null;

  try {
    const saved = window.localStorage.getItem(storageKey);
    if (validMode(saved)) preference = saved;
  } catch {}

  const updateControls = () => {
    const dark = root.getAttribute('data-theme') === 'dark';
    document.querySelectorAll('.theme-toggle').forEach(button => {
      button.setAttribute('aria-pressed', String(dark));
    });
    document.querySelectorAll('.theme-toggle .icon-sun').forEach(icon => {
      icon.style.display = dark ? 'block' : 'none';
    });
    document.querySelectorAll('.theme-toggle .icon-moon').forEach(icon => {
      icon.style.display = dark ? 'none' : 'block';
    });
  };

  const applyTheme = () => {
    const mode = preference || (validMode(storeDefault) ? storeDefault : system.matches ? 'dark' : 'light');
    root.setAttribute('data-theme', mode);
    updateControls();
  };

  applyTheme();
  document.addEventListener('DOMContentLoaded', updateControls);
  document.addEventListener('shopify:section:load', updateControls);
  system.addEventListener('change', applyTheme);

  document.addEventListener('click', event => {
    if (!event.target.closest('.theme-toggle')) return;
    event.preventDefault();
    preference = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    applyTheme();
    try {
      window.localStorage.setItem(storageKey, preference);
    } catch {}
  });

  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    preference = validMode(event.newValue) ? event.newValue : null;
    applyTheme();
  });
})();
